import store from '@/store/store';
import * as config from '@/configuration/clientConf';
import { addClients, updateClient, browseDetailClient } from '@/api/clients';
import { insertPieceJointe, updatePieceJointe } from '@/services/piecesJointes/savePiecesJointes';
import generePJ from '@/services/piecesJointes/genererPiecesJointes';
import { getLogoFileFromDataURI } from '@/services/concurrent/concurrent';
import preparationEnvoiBackMandats from '@/services/mandat/preparationEnvoiBackMandat';
import { MODULE_CLIENT, PIECE_JOINTE_TYPE_LOGO } from '@/configuration/pieceJointeConf';

async function gestionPiecesJointe(client, pointDeVente) {
  const file = getLogoFileFromDataURI(pointDeVente.srcImg);
  if (!file) return null;
  const fileData = { file, placeType: PIECE_JOINTE_TYPE_LOGO };
  const pieceJointesData = await generePJ([fileData]);
  const funcAsync = pointDeVente.urlLogo ? updatePieceJointe : insertPieceJointe;
  await funcAsync(pieceJointesData, client.id, MODULE_CLIENT);
}

async function createPointDeVente(pointDeVente) {
  pointDeVente.societeId = store.getters['societe/societeActiveId'];
  pointDeVente.sousTypes = [config.SOUS_TYPE_AUCUN];
  const res = await addClients(pointDeVente);
  return res;
}

export async function createOrUpdatePointDeVente(pointDeVente) {
  const funcAsync = pointDeVente.id ? updateClient : createPointDeVente;
  const payload = {
    ...pointDeVente,
    mandats: preparationEnvoiBackMandats(pointDeVente.mandats),
  };
  const client = (await funcAsync(payload)).data;
  await gestionPiecesJointe(client, pointDeVente);
  if (client.tiersParentId && !client.tiersParent) {
    client.tiersParent = (await browseDetailClient(client.tiersParentId)).data;
  }
  return client;
}
